<template>
  <div
    class="content-container-wrapper"
    :class="{
      'flex flex-1 flex-col h-full overflow-hidden': !smallHeight,
      'h-auto min-h-full': smallHeight,
    }"
  >
    <div v-if="showTitle && title" class="module-card-title !mb-[20px]">
      {{ title }}
    </div>

    <div class="relative pr-[24px] overflow-hidden flex flex-col">
      <slot />

      <div
        class="content-footer justify-center"
        :class="[
          { '!p-0': !slots.footer },
        ]"
      >
        <slot
          v-if="slots.footer && showFooter"
          name="footer"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, watch } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { settings } from '@core/api';

defineOptions({ name: 'ContentContainer' });

const slots = defineSlots();
const { height } = useWindowSize();

const smallHeight = computed(() => height.value <= settings.smallHeight);

const props = defineProps({
  /** content 区域的标题 */
  showTitle: {
    type: Boolean,
    default: false,
  },
  /** content 区域的标题 */
  title: {
    type: String,
    required: false,
    default: '',
  },
  /** 是否显示底部区域 */
  showFooter: {
    type: Boolean,
    default: true,
  },
  tableRowCount: {
    type: Number,
    default: 0,
  },
});

watch(
  () => props.tableRowCount,
  () => {
    nextTick(() => {
      const table = document.querySelector('.el-table') as HTMLDivElement;

      if (!table) return;
      table.style.height = 'auto';

      const scroller = table.querySelector('.el-scrollbar__wrap') as HTMLDivElement;

      if (scroller) scroller.style.overflow = 'hidden';

      setTimeout(() => {
        if (scroller) scroller.style.overflow = 'auto'; // 延迟180ms，等待el-table渲染完成（el-table有时候渲染不完整）

        if (!smallHeight.value) return;

        if (props.tableRowCount > 10) {
          table.style.height = '540px';
        } else {
          table.style.height = table.clientHeight + 3 + 'px';
        }
      }, 100);
    });
  },
);

</script>

<style lang="scss" scoped>
.content-container-wrapper {
  @apply bg-white rounded-[2px] p-6 pr-[0] relative;

  :deep(.normal-table .el-table__inner-wrapper) {
    height: calc(100% + 1px);
  }
}

.content-footer {
  @apply pt-[16px] flex;
}
</style>
